import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ResponseDto } from '@models/exceptions/response-dto';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { Observable } from 'rxjs';
import { BaseService } from './base-service';
import { SKIP_LOADING } from '../../http/skip-loading.token';
import { HttpContext } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DocumentVaildationService extends BaseService {
  private url: string = environment.apiUrl + '/v1/validar-documentos-contatos';

  constructor() {
    super();
  }

  getValidation(
    campo: string,
    tipoCampoValidacaoEnum: TipoCampoValidacaoEnum,
    usuNrId: number | null,
  ): Observable<ValidadorDocumentosEhContatosDto> {
    return this.http
      .post<
        ResponseDto<ValidadorDocumentosEhContatosDto>
      >(this.url, { campo, tipoCampoValidacaoEnum, usuNrId }, { context: new HttpContext().set(SKIP_LOADING, true) })
      .pipe(extractResponse());
  }
}

export enum TipoCampoValidacaoEnum {
  CPF = 'CPF',
  TELEFONE = 'TELEFONE',
  EMAIL = 'EMAIL',
}

export interface ValidadorDocumentosEhContatosDto {
  isMesmaFederacao : boolean;
  fedTxNome : string;
  usuTxNome : string;
  usuNrId : number;
  usuTxCampo : string;
}
